import React, { useId } from 'react'

import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'

type BaseSelectProps = {
  value: number | string | any[]
  onChange: (...args: any[]) => any
  allowEmpty?: boolean
  className?: string
  disabled?: boolean
  errorId?: string | boolean
  fullWidth?: boolean
  label?: string
  multiple?: boolean
  options?: any
}

const BaseSelect = ({
  value,
  onChange = () => {},
  allowEmpty = true,
  className = '',
  disabled = false,
  errorId,
  fullWidth = true,
  label = '',
  multiple = false,
  options = [],
}: BaseSelectProps) => {
  // Links the label to the select (client-only SPA, no SSR).
  const labelId = useId()

  return (
    <FormControl className={className} disabled={disabled} error={!!errorId} fullWidth={fullWidth}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        disabled={disabled}
        error={!!errorId}
        fullWidth={fullWidth}
        label={label}
        labelId={labelId}
        multiple={multiple}
        onChange={(e: any) => onChange(e.target.value)}
        value={value}>
        {!multiple && allowEmpty && (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
        {options.map(({ value: optionValue, label: optionLabel }: any) => (
          <MenuItem key={optionValue} value={optionValue}>
            {optionLabel}
          </MenuItem>
        ))}
      </Select>
      {errorId && <FormHelperText>{errorId}</FormHelperText>}
    </FormControl>
  )
}

export default BaseSelect
